import React, { useEffect, useRef, useState } from "react";
import css from "./carosal.module.scss";
import { IconArrow } from "re_redesigned_componnents/icon";
import CarosalCard from "re_redesigned_componnents/card/CarosalCard";
import aiCourse from '../asset/ai_gen_courses.png'
import aiAssessment from '../asset/ai_gen_assessment.png'
import events from '../asset/events.png'
import live from '../asset/live_section.png'

function Carosal(props) {
  const demo = [

    {
      // type: "AI Generated Courses",
      description: "Hand-picked. Expert-led. Designed for learners who mean business. Explore premium courses built to deliver real results.",
      title: "Premium Courses",
      image: aiCourse,
      buttonTitle: "View",
      buttonClick: props.ai
    },
    {
      description: "Experience the power of AI-generated assessments that provide instant, personalized feedback to accelerate your learning and growth!",
      title: "AI Generated Assessments",
      image: aiAssessment,
      buttonTitle: "View"
    },
    {
      description: "Join us for an exclusive live session where you’ll gain expert insights, interactive learning, and the opportunity to get your questions answered in real-time!",
      title: "Live Sessions",
      image: live,
      buttonTitle: "Join",
      buttonClick: props.onLiveClick
    },
    {
      description: "Join us for an exciting event filled with opportunities to learn, connect, and grow!",
      title: "Events",
      image: events,
      buttonTitle: "View",
      buttonClick: props.onEventClick
    },
  ];

  const [current_index, setCurrent_index] = useState(0);
  const [safe_mode, setSafe_mode] = useState(demo.length - 1);
  const intervalTime = 6000;
  const sliderRef = useRef();
  const intervalRef = useRef();

  useEffect(() => {
    if (demo.length > 0) {
      setSafe_mode(demo.length - 1);
    }
  }, [demo]);

  useEffect(() => {
    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        handleNext();
      }, intervalTime);
    };
    startAutoScroll();
    return () => clearInterval(intervalRef.current);
  }, []);

  const resetAutoScroll = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => handleNext(), intervalTime);
  };

  const handleNext = () => {
    setCurrent_index((prev) => (prev < safe_mode ? prev + 1 : 0));
    resetAutoScroll();
  };

  const handlePrev = () => {
    setCurrent_index((prev) => (prev > 0 ? prev - 1 : safe_mode));
    resetAutoScroll();
  };

  return (
    <div className={css.carosal_wrap}>
      <button className={css.prev} onClick={handlePrev}>
        <IconArrow />
      </button>
      <div className={css.content} id={css.slider} ref={sliderRef}
        style={{
          transform: `translateX(-${current_index * 100}%)`,
        }}
      >
        {demo.map((element, index) => (
          <div key={index} className={css.scroll_item}>
            <CarosalCard
              title={element?.title || ""}
              image={element?.image || ""}
              type={element?.type}
              description={element.description}
              buttonTitle={element?.buttonTitle}
              buttonClick={element?.buttonClick}
            />
          </div>
        ))}
      </div>
      <button className={css.next} onClick={handleNext}>
        <IconArrow />
      </button>

      <div className={css.indication_wrap}>
        {demo.map((_, index) => (
          <div
            key={index}
            className={index === current_index ? css.active : css.inactive}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default Carosal;
